import React, { Component } from 'react';
import { connect } from 'react-redux';

class MarketTitle extends Component {
  render(){
    return (
      <div className='row' style={{marginRight:'1px',marginLeft:'1px',marginTop:'5px'}}>
        <h5 className='white-text' style={{marginBottom:'',marginTop:'5px'}}> {this.props.text} </h5>
      </div>
    )
  }
}

function mapStateToProps(state,props) {
  return {
    text:`${state.ui_marketplace.market.asset}/${state.ui_marketplace.market.denomination}`
  };
}

export default connect(mapStateToProps, {})(MarketTitle);
